import { MapConstants, MarkerConstants } from "../_constants";

const initialState = {
  loading: false,
  items: [],
  error: undefined,
  params: undefined,
};

export function markers(state = initialState, action) {
  switch (action.type) {
    case MarkerConstants.POPULATE_MARKERS: {
      const { payload } = action;
      return {
        ...state,
        items: [...payload],
      };
    }

    case MarkerConstants.FETCH_MAP_MARKERS_REQUEST: {
      const { props } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        props,
      };
    }

    case MarkerConstants.FETCH_MAP_MARKERS_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        items: [...payload],
        error: undefined,
        props: undefined,
      };
    }

    case MarkerConstants.FETCH_MAP_MARKERS_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error,
      };
    }

    case MarkerConstants.FETCH_CHRONICLE_MARKERS_REQUEST: {
      const { props } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        props,
      };
    }

    case MarkerConstants.FETCH_CHRONICLE_MARKERS_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        loading: false,
        error: undefined,
        items: [...payload],
        props: undefined,
      };
    }

    case MarkerConstants.FETCH_CHRONICLE_MARKERS_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error,
      };
    }

    case MarkerConstants.CREATE_MARKER_REQUEST: {
      const { props } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params: props,
      };
    }

    case MarkerConstants.CREATE_MARKER_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        items: [...state.items, payload],
        loading: false,
        error: undefined,
        props: undefined,
      };
    }

    case MarkerConstants.CREATE_MARKER_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error,
      };
    }

    case MarkerConstants.UPDATE_MARKER_REQUEST: {
      const { props } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        props,
      };
    }

    case MarkerConstants.UPDATE_MARKER_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.findIndex((i) => i._id === payload._id);
      const newItems = [
        ...state.items.slice(0, oldItemIndex),
        payload,
        ...state.items.slice(oldItemIndex + 1),
      ];

      return {
        ...state,
        loading: false,
        error: undefined,
        props: undefined,
        items: newItems,
      };
    }

    case MarkerConstants.UPDATE_MARKER_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error,
      };
    }

    case MarkerConstants.DELETE_MARKER_REQUEST: {
      const { props } = action;

      return {
        ...state,
        loading: true,
        error: undefined,
        props,
      };
    }

    case MarkerConstants.DELETE_MARKER_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.findIndex((i) => i._id === payload);
      const newItems = [
        ...state.items.slice(0, oldItemIndex),
        ...state.items.slice(oldItemIndex + 1),
      ];

      return {
        ...state,
        error: undefined,
        props: undefined,
        loading: false,
        items: newItems,
      };
    }

    case MapConstants.REFRESH_EVENTS_AND_MARKERS: {
      const { payload } = action;
      let newItems;
      if (payload.markers) {
        const removedIDs = payload.markers.map((m) => m._id);
        newItems = state.items.filter((i) => removedIDs.indexOf(i._id) < 0);
      } else {
        newItems = state.items;
      }

      return {
        ...state,
        items: [...newItems],
      };
    }

    // case MarkerConstants.UPDATE_MAKRERS_MAP_DELETE: {
    //   const removedMapID = action.payload;
    //   const itemsRemoved = state.items.filter(
    //     (i) => i.parentMap === removedMapID
    //   );
    //   const newItems = state.items.filter((i) => i.parentMap !== removedMapID);
    //   return {
    //     ...state,
    //     items: newItems,
    //   };
    // }

    default: {
      return state;
    }
  }
}
